<template>
  <div class="tenant-nav-status">
    <el-dropdown
      class="tenant-session-switcher"
      trigger="click"
      @command="$emit('session-command', $event)"
    >
      <span class="tenant-session-trigger" role="button" tabindex="0">
        {{ currentTenantLabel }}
        <i class="el-icon-arrow-down el-icon--right" />
      </span>
      <el-dropdown-menu slot="dropdown" class="tenant-session-menu">
        <el-dropdown-item
          v-for="session in normalizedSessions"
          :key="session.tenantCode"
          :command="`tenant:${session.tenantCode}`"
          :class="{ 'is-active-session': session.active }"
        >
          <div class="tenant-session-option">
            <span>{{ session.tenantName }}（{{ session.tenantCode }}）</span>
            <small>{{ session.displayName }}</small>
            <i v-if="session.active" class="el-icon-check" />
          </div>
        </el-dropdown-item>
        <el-dropdown-item divided command="add-account">
          <i class="el-icon-plus" />
          <span>{{ addAccountLabel }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <span class="tenant-nav-language">{{ languageLabel }}</span>
    <el-dropdown @command="$emit('user-command', $event)">
      <div class="avatar-wrapper">
        <svg-icon class="tenant-user-icon" iconName="tenant-nav-user" />
        <span class="user-info">
          <span class="user-nickname">{{ displayName }}</span>
          <i class="el-icon-caret-bottom" />
        </span>
      </div>
      <el-dropdown-menu slot="dropdown" class="user-dropdown">
        <slot name="user-menu" />
      </el-dropdown-menu>
    </el-dropdown>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TenantStatusBar',
  props: {
    currentTenantLabel: {
      type: String,
      default: ''
    },
    tenantSessions: {
      type: Array,
      default: () => []
    },
    addAccountLabel: {
      type: String,
      default: ''
    },
    languageLabel: {
      type: String,
      default: ''
    },
    displayName: {
      type: String,
      default: ''
    }
  },
  computed: {
    normalizedSessions() {
      return Array.isArray(this.tenantSessions)
        ? this.tenantSessions.filter(Boolean)
        : []
    }
  }
}
</script>
